import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { CommissionReportRoutingModule } from './commission-report-routing.module';
import { CommissionReportComponent } from './commission-report.component';
import { VatStatementComponent } from './vat-statement/vat-statement.component';
import { PipeModule } from '@nttp/pipes/pipe.module';

@NgModule({
  imports: [
    CommonModule,
    CoreUiModule,
    CoreMaterialModule,
    ReactiveFormsModule,
    CommissionReportRoutingModule,
    NgTableModule,
    PipeModule
  ],

  declarations: [CommissionReportComponent, VatStatementComponent],
  entryComponents: [VatStatementComponent]
})
export class CommissionReportModule { }
